import React from 'react';
import fr from 'facet-rest';
import { FDTextButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const PlannerTransitionSegmentKeyButton = ({
  plannerTransitionHouseholdPageResource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const PlannerTransitionSegmentKeyButtonComponent = plannerTransitionHouseholdPageResource.withRelationship(
    fr.relationships.plannerTransitionSegmentKey.name,
    (plannerTransitionSegmentKeyRel) => (
      <FDTextButton
        icon={'info'}
        label={plannerTransitionSegmentKeyRel.meta('prompt')}
        size={'sm'}
        onClick={() => {
          loadModalCollectionByLink(
            plannerTransitionSegmentKeyRel.link('related').url(),
          );
        }}
      />
    ),
    () => null,
  );

  return PlannerTransitionSegmentKeyButtonComponent;
};

PlannerTransitionSegmentKeyButton.defaultProps = {
};

PlannerTransitionSegmentKeyButton.propTypes = {
  plannerTransitionHouseholdPageResource: PropTypes.object.isRequired,
};

export default PlannerTransitionSegmentKeyButton;
